<template>
  <transition name="scroll">
    <div id="page-members">
      <h2 class="has-text-centered has-text-weight-bold is-c-text is-cs-2">メンバー</h2>
      <dl>
        <dt>管理者</dt>
        <dd v-for="(member, i) in members" :key="i">
            <figure class="image is-24x24" v-for="image in [member.images[0]]" :key="image.full_path">
              <cachalog-img class="is-rounded" :caption="image.caption" :type="'background'"
              :full-path="image.full_path" :source="image.source"></cachalog-img>
            </figure>
          <span>{{ member.nickname }}</span>
          <span v-if="member.uid === user.uid">（あなた）</span>
        </dd>
      </dl>
    </div>
  </transition>
</template>

<script>
import Vuex from 'vuex'
import { mixin } from './common.js'
export default {
  mixins: [mixin],
  props: ['pageId'],
  computed: {
    ...Vuex.mapState({
      user: 'user',
      page: 'page',
      members: 'members'
    }),
    pageTitle () {
      return this.page.title || ''
    }
  },
  watch: {
    page (value) {
      this.$store.dispatch('fetchMembers', value.members)
    }
  },
  created () {
    this.$store.commit('changePageMainComponent', 'page-members')
    if (!this.members.length) {
      this.$store.dispatch('fetchMembers', this.page.members)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-members.vue